import React from 'react';

import MiniCard from '../MiniCard';
import { EventAttributes } from '../../constants/types';

interface Props {
  actionType: EventAttributes,
  onClick?: () => void
}

const ActionTypeMiniCard = ({ actionType, onClick }: Props) => (
  <MiniCard
    icon={actionType.icon}
    label={actionType.stepTitle}
    description={actionType.stepDescription}
    onClick={onClick}
  />
);

export default ActionTypeMiniCard;
